module.exports = __webpack_public_path__ + "img/no-label.d98bbf51.svg";